import { apiGateway } from '../api';

export async function getNotificacoesPorContrato(numContrato, tipo) {
    const body = { numContrato, tipo };

    try {
        return await apiGateway.post(`/notificacoes/portal`, body);
    } catch (error) {
        return error;
    }
}
